import { useEffect, useMemo, useRef, useState } from "react";

import { DeploymentService } from "@packages/client";

import { ObservabilityPipelineResourcesByService } from "Api/observability/pipeline/types";
import { Poller } from "src/organization/pages/project/environment/metrics/utils/polling/poller";
import { MetricsPollType } from "src/organization/pages/project/environment/metrics/utils/polling/type";

import { buildMetrics } from "./util";

type Props = Omit<
  MetricsPollType<ObservabilityPipelineResourcesByService>,
  "timeframe"
> & {
  service: DeploymentService;
};

const usePoll = ({ onChange, onLoadingChange }: Props) => {
  const [resource, setResource] =
    useState<ObservabilityPipelineResourcesByService>();

  const { metrics, instances } = useMemo(() => {
    const data = buildMetrics(resource?.data);
    return data;
  }, [resource]);

  const poller = useRef<Poller<ObservabilityPipelineResourcesByService>>(
    new Poller<ObservabilityPipelineResourcesByService>({
      onChange: resource => {
        onChange(resource);
        setResource(resource);
      },
      onError: () => onChange(),
      onLoadingChange
    })
  ).current;

  const servicesInstance = useMemo(
    () => (instances.length > 1 ? [...instances, "average"] : instances).sort(),
    [instances]
  );

  useEffect(() => {
    return () => poller.stopPolling();
  }, [poller]);

  return { instances: servicesInstance, metrics, poller };
};

export default usePoll;
